<template>
    <button
        role="button"
        :class="{'w-full': !widthFit}"
        class="flex justify-between gap-8 bg-primary-5 rounded py-12 px-16 text-start"
        @mouseover="hovering = true"
        @mouseleave="hovering = false"
        @mousedown="copyContent"
    >
        <slot>{{ text }}</slot>
        <svg-icon class="w-18 h-18" :type="hovering ? 'content-copy-filled' : 'content-copy'" />
    </button>
</template>
<script>
import {copyToClipboard} from '../../../shared/helpers';
import SvgIcon from './SvgIcon';
export default {
    name: "CopyToClipboard",
    components: {
        SvgIcon,
    },
    props: {
        text: String,
        copyValue: String|Array,
        widthFit: Boolean,
    },
    data() {
        return {
            hovering: false,
        }
    },
    methods: {
        copyContent() {
            if (this.copyValue) {
                if (!Array.isArray(this.copyValue)) copyToClipboard(this.copyValue)
                else {
                    let text = this.copyValue[0];
                    let subject = this.copyValue[1];
                    copyToClipboard(text, subject);
                }
            } else {
                copyToClipboard(this.text);
            }
        },
    }
}
</script>
<style scoped>

</style>